// @flow
import createMaybeTransform from 'app/common/react/components/closeup/utils/createMaybeTransform';
import { type Video } from 'app/packages/pinterest-flow-types/video';
import { type VideoDetails } from 'app/common/react/components/closeup/lib';
import type { HasPin, MaybeAToMaybeAB } from 'app/common/react/components/closeup/utils/types';

type HasVideo = {
  video: VideoDetails,
};

type ToMaybeHasVideo = MaybeAToMaybeAB<HasPin, HasVideo>;

const toMaybeVideo: (video: Object) => ?Video = (video) => {
  const { thumbnail, url, width, height, duration } = video || {};
  return (
    (thumbnail && url && width && height && { thumbnail, url, width, height, duration }) ||
    undefined
  );
};

const hasVideo: ToMaybeHasVideo = createMaybeTransform((props) => {
  const { videos } = props.pin;
  const { id, video_list: videoList = {} } = videos || {};
  const { V_720P: _mp4, V_HLSV4: _hls, V_HLSV3_MOBILE: _hlsv3 } = videoList;
  const hls = toMaybeVideo(_hls);
  const hlsv3 = toMaybeVideo(_hlsv3);
  const mp4 = toMaybeVideo(_mp4);

  const hasVideo = mp4 || hls || hlsv3;
  return id && hasVideo
    ? {
        ...props,
        video: {
          id,
          hasVideo,
          mp4: !!mp4 ? mp4 : undefined,
          hls: !!hls ? hls : undefined,
          hlsv3: !!hlsv3 ? hlsv3 : undefined,
        },
      }
    : null;
});

export default hasVideo;
